import React from "react";
import Hero from "./Hero";
import Brokerage3 from "./Brokerage3";
import Charges from "./Charges";

function PricingPageCommodity() {
    return ( 
        <>
      <Hero />
      <Brokerage3/>
      <Charges/>
    </>
     );
}

export default PricingPageCommodity;